import { type Content } from '@radix-ui/react-popover'
import { type ComponentProps } from 'react'

import { FLOATING_COLLISION_PADDING, type FloatingContentType } from '@/defs/floating'
import { getClickawayIgnoreProps } from '@/utils/clickawayUtil'

import styles from './Floating.module.scss'

type Props = {
  className?: string
} & Pick<FloatingContentType, 'ignoreScopes' | 'placement'>

export const getFloatingContentProps = ({
  className = styles.radixContent,
  ignoreScopes = 'allScopes',
  placement,
}: Props): ComponentProps<typeof Content> => ({
  align: 'center',
  avoidCollisions: true,
  className,
  collisionPadding: FLOATING_COLLISION_PADDING,
  side: placement,
  ...getClickawayIgnoreProps(ignoreScopes),
})
